import React from 'react';
import { motion } from 'framer-motion';
export function Privacy() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white min-h-screen py-20" data-id="element-546">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-547">
        <h1 className="text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter" data-id="element-548">
          Privacy Policy
        </h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed" data-id="element-549">
          <p className="text-lg font-medium text-slate-900" data-id="element-550">
            Effective Date: May 19, 2026
          </p>
          <p data-id="element-551">
            At Daily Care Pharmacy, we are committed to protecting your privacy.
            This Privacy Policy explains how we collect, use, and safeguard your
            personal information when you use our website and services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-552">
            Information We Collect
          </h2>
          <p data-id="element-553">
            We collect information you provide directly to us, such as when you
            create an account, fill out a prescription refill request, or
            contact us for health consulting. This may include your name,
            contact information, and health-related data.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-554">
            How We Use Your Information
          </h2>
          <p data-id="element-555">
            We use your information to provide and improve our pharmaceutical
            services, communicate with you about your prescriptions, and ensure
            compliance with legal and regulatory requirements.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-556">
            Data Security
          </h2>
          <p data-id="element-557">
            We implement industry-standard security measures to protect your
            data from unauthorized access, disclosure, or alteration. Your
            health information is handled with the highest level of
            confidentiality.
          </p>
        </div>
      </div>
    </motion.div>;
}